module.exports = __webpack_public_path__ + "img/ergonomics_and_mobilization.2d328f13.jpg";